module.exports = __webpack_public_path__ + "static/media/hbogo.5325d71d.png";